export const Discount = () => {
  return (
    <div className="mt-10 bg-serenade">
      <div className="max-w-[85%] sm:max-w-[75%] lg:max-w-[85%] xl:max-w-[75%] m-auto py-10 text-center">
        <div className="uppercase text-2xl font-semibold">ОФІЦІЙНИЙ СТАРТ</div>
        <div className="text-4xl font-semibold">−30% для перших клієнтів</div>
        <div className="text-xl mt-2">
          Даруємо нове життя вашим спогадам, створюючи яскраві візуальні історії
          з професійною колоризацією та щирими емоційними відео.
        </div>
      </div>
    </div>
  );
};
